(() => {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const reveal = (root = document) => {
    if (reduced.matches || !('IntersectionObserver' in window)) return;
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        entry.target.classList.remove('dm-reveal-pending');
        entry.target.classList.add('dm-reveal-visible');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.06 });
    root.querySelectorAll('[data-dm-reveal]').forEach(element => {
      if (element.dataset.dmReady) return;
      element.dataset.dmReady = 'true';
      if (element.getBoundingClientRect().top < window.innerHeight) return;
      element.classList.add('dm-reveal-pending');
      observer.observe(element);
    });
    reduced.addEventListener('change', event => {
      if (!event.matches) return;
      root.querySelectorAll('.dm-reveal-pending').forEach(element => element.classList.remove('dm-reveal-pending'));
      observer.disconnect();
    }, { once: true });
  };
  const closeMenu = event => {
    document.querySelectorAll('.dn-mobile-nav[open]').forEach(menu => {
      if (!menu.contains(event.target)) menu.open = false;
    });
  };
  document.addEventListener('click', closeMenu);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => reveal());
  else reveal();
  document.addEventListener('shopify:section:load', event => reveal(event.target));
  document.addEventListener('shopify:section:select', event => {
    event.target.querySelectorAll('.dm-reveal-pending').forEach(element => element.classList.remove('dm-reveal-pending'));
  });
})();
